import { useGo } from "@refinedev/core";
import { MediaProjectListItem } from "../../types";
import { type TableProps } from "antd";
import { ColumnsType } from "antd/es/table";
import { StyledExperiencesTable } from "helpers/table/StyledExperiencesTable";
import { centeredPagination } from "helpers/table/tableUtils";
import { getProjectDetailRoute } from "../../projects/helpers/helper";

export const ProjectsTable = ({
  tableProps,
  columns,
  components,
}: {
  tableProps: TableProps<MediaProjectListItem>;
  columns: ColumnsType<MediaProjectListItem>;
  components?: TableProps<MediaProjectListItem>["components"];
}) => {
  const go = useGo();
  const handleProjectClick = (record: MediaProjectListItem) => {
    go({ to: getProjectDetailRoute(record.id, record.type) });
  };

  return (
    <StyledExperiencesTable
      {...tableProps}
      pagination={centeredPagination(tableProps.pagination)}
      rowKey="id"
      columns={columns}
      components={components}
      dataSource={tableProps.dataSource ?? []}
      onRow={(record) => {
        const projectUrl = getProjectDetailRoute(record.id, record.type);
        return {
          onClick: (event: React.MouseEvent) => {
            // If Ctrl+click or Cmd+click, open in new tab
            if (event.ctrlKey || event.metaKey) {
              event.preventDefault();
              window.open(projectUrl, "_blank");
              return;
            }
            // Normal click
            handleProjectClick(record);
          },
          style: {
            cursor: "pointer",
          },
        };
      }}
    />
  );
};
